import { toISODate } from '../utils/paymentOrdersUtils';

export const DEFAULT_ROWS_PER_PAGE = 10;

export const PAYMENT_ORDER_STATUS_FILTERS = [
  { value: 'all', label: 'Todos' },
  { value: 'pending', label: 'Pendiente' },
  { value: 'paid', label: 'Pagada' },
  { value: 'cancelled', label: 'Anulada' },
];

export const createDefaultFilters = () => {
  const today = new Date();
  const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);

  return {
    start_date: toISODate(firstDay),
    end_date: toISODate(today),
    uuid_legal_entity: '',
    status: 'all',
    cost_behavior: '',
    cost_traceability: '',
    cost_area: '',
  };
};
